import React, { useEffect, useState } from 'react';
import { Player } from '../models/player';
import FindPlayer from './find-player';
import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { usePlayer } from '../context/PlayerContext';
import { useRedirect } from '../context/RedirectContext';

interface Props {
    redirectUrl?: string;
}

const PlayerWindow: React.FC<Props> = (props: Props) => {

    const { redirectUrl } = props;
    const { player, setPlayer } = usePlayer();

    const { url, setUrl } = useRedirect();

    useEffect(() => {
        setUrl(redirectUrl);
    }, [redirectUrl]);

    const playerFound = async (player: Player) => {
        await setPlayer(player);
    }

    const clearPlayerCache = async () => {
        localStorage.removeItem('player');
        await setPlayer(null);
    }

    const goToPlayerProfile = () => {
        if (player && player.id) {
            window.location.href = `/players/${player.id}`;
        }
    }

    return (
        <div>
            <Card>
                <Card.Header>
                    {player ? <> Player profile</>
                        :
                        <>No active player on this device</>
                    }

                </Card.Header>
                <Card.Body>
                    <div className='player-window-body'>
                        {player ? (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ textAlign: 'left' }}>
                                        <label>NAME</label>
                                        <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{player.firstName}</div>
                                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{player.lastName}</div>
                                    </div>
                                    {player.imageUrl && (
                                        <div>
                                            <img
                                                src={player.imageUrl}
                                                alt={`${player.firstName} ${player.lastName}`}
                                                style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                <FindPlayer onPlayerFound={playerFound} />
                            </>
                        )}
                    </div>
                </Card.Body>
                <Card.Footer>
                    <Button variant="primary" disabled={!player} style={{ marginRight: '0.5rem' }} onClick={goToPlayerProfile}>
                        GO TO PROFILE
                    </Button>
                    <Button variant="secondary" disabled={!player} onClick={clearPlayerCache}>
                        NOT YOU?
                    </Button>
                </Card.Footer>
            </Card>

        </div>
    );
}

export default PlayerWindow;